module.exports = __webpack_public_path__ + "img/photo-03-2.aecdea77.jpg";